// Header Sticky Behavior
class StickyHeader {
  constructor() {
    this.headerWrapper = document.querySelector('.header-wrapper');
    this.headerSection = document.querySelector('#shopify-section-header');
    this.isScrolled = false;
    this.lastScrollTop = 0;
    this.stickyEnabled = false;

    if (!this.headerWrapper) return;

    // Check if sticky is enabled from the setting
    this.stickyEnabled =
      this.headerWrapper.dataset.sticky === 'true' ||
      this.headerWrapper.classList.contains('is-sticky');

    // Apply is-sticky to the section if enabled
    if (this.stickyEnabled && this.headerSection) {
      this.headerSection.classList.add('is-sticky');
    }

    this.init();
  }

  init() {
    // Set initial CSS variables
    this.adjustCSSVariables();

    // Listen for scroll events
    window.addEventListener('scroll', this.onScroll.bind(this), {
      passive: true,
    });

    // Listen for resize events
    window.addEventListener('resize', this.adjustCSSVariables.bind(this), {
      passive: true,
    });

    // Initial scroll check
    this.onScroll();
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 0) {
      // Scrolled down - add is-scrolled for styling changes
      if (!this.isScrolled) {
        this.isScrolled = true;
        this.headerWrapper.classList.add('is-scrolled');
        this.headerWrapper.setAttribute('is-scrolled', '');
      }
    } else {
      // At top - remove is-scrolled
      if (this.isScrolled) {
        this.isScrolled = false;
        this.headerWrapper.classList.remove('is-scrolled');
        this.headerWrapper.removeAttribute('is-scrolled');
      }
    }

    this.lastScrollTop = scrollTop;
    this.adjustCSSVariables();
  }

  adjustCSSVariables() {
    // Get heights of header elements
    const announcement = document.querySelector('.js-header-announcement');
    const header = document.querySelector('.header');
    const countdown = document.querySelector('.countdown-timer');
    const announcementHeight = announcement ? announcement.offsetHeight : 0;
    const headerHeight = header ? header.offsetHeight : 0;
    const countdownHeight = countdown ? countdown.offsetHeight : 0;
    const totalOffset = announcementHeight + headerHeight + countdownHeight;
    const withCountdownOffset = headerHeight + countdownHeight;

    // Set CSS variables for use throughout the site
    document.documentElement.style.setProperty(
      '--announcement-height',
      `${announcementHeight}px`
    );
    document.documentElement.style.setProperty(
      '--header-height',
      `${headerHeight}px`
    );
    document.documentElement.style.setProperty(
      '--countdown-height',
      `${countdownHeight}px`
    );

    if (countdownHeight !== 0) { 
      document.documentElement.style.setProperty(
        '--announcement-z-index',
        `98`
      );
    } else {
      document.documentElement.style.setProperty(
        '--announcement-z-index',
        `901`
      );
    }

    // When scrolled, only use header height (announcement is hidden)
    if (this.isScrolled) {
      document.documentElement.style.setProperty(
        '--header-offset',
        `${withCountdownOffset}px`
      );
    }
    else {
      document.documentElement.style.setProperty(
        '--header-offset',
        `${totalOffset}px`
      );
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyHeader();
  });
} else {
  new StickyHeader();
}
